export const rowSx = {
  display: "table",
  width: "100%",
};

export const leftCellSx = {
  position: "sticky",
  left: "0px",
  zIndex: 10,
  minWidth: "220px",
  width: "220px",
  whiteSpace: "nowrap",
  backgroundColor: "white",
  border: "none",
};

export const questionTypeSx = {
  minWidth: "190px",
  maxWidth: "190px",
};

export const middleCellSx = {
  minWidth: "180px",
  maxWidth: "180px",
};

export const rightCellSx = {
  position: "sticky",
  right: "0px",
  zIndex: 10,
  width: "130px",
  minWidth: "130px",
  whiteSpace: "nowrap",
  background: "white",
};
